'use strict';
module.exports = function toFastproperties(o) {
	function Sub() {}
	Sub.prototype = o;
	var receiver = new Sub(); // create an instance
	function ic() { return typeof receiver.foo; } // perform access
	ic(); 
	ic();
	return o;
	eval("o" + o); // ensure no dead code elimination
}



//////////////////
// WEBPACK FOOTER
// ./~/to-fast-properties/index.js
// module id = 4768
// module chunks = 168707334958949